import React, { useEffect, useState } from 'react'
import SigninForm from './SignInForm'
import SignUpForm from './SignUpForm'
import FrogetPasswordForm from './FrogetPasswordForm'
import { useSelector } from 'react-redux'

const UserLoginForm = () => {


    const forgetPassword = useSelector((state) => state.forgetPassword.forgetPasswordData)


    const [isSignUp, setIsSignUp] = useState(false)
    const [isForgetPassword, setIsForgetPassword] = useState(false)

    const switchIsSignUp = () => {
        setIsSignUp(!isSignUp)
    }

    const handleForgetPassword = () => {
        setIsForgetPassword(!isForgetPassword)
    }


    useEffect(() => {

        if (forgetPassword) {
            setTimeout(() => {
                setIsForgetPassword(false)
            }, 5000)
        }

    }, [forgetPassword])

    return (

        isForgetPassword ?
            <FrogetPasswordForm handleForgetPassword={handleForgetPassword} />
            :
            isSignUp ?
                <SignUpForm handleSwitchPage={switchIsSignUp} />
                :
                <SigninForm handleSwitchPage={switchIsSignUp} handleForgetPassword={handleForgetPassword} />


    )
}

export default UserLoginForm
